/**
 * Append scripts from admin panel
 * @param {Object} scripts
 * @param {string} scripts.head.end
 * @param {string} scripts.body.begin
 * @param {string} scripts.body.end
 */
export default {
  computed: {
    stockScript () {
      return `<script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-XXXX');</script>`
    }
  },

  methods: {
    appendScriptsToHeadAndBody (scripts) {
      const range = document.createRange()

      // append to head
      if (scripts.hasOwnProperty('head')) {
        const head = document.getElementsByTagName('head')[0]

        try {
          range.setStart(head)
        } catch (err) {
          range.setStart(head, 0) // - didn't work for moderately old iOS
        }

        if (scripts.head.end) {
          head.appendChild(
            range.createContextualFragment(scripts.head.end)
          )
        }
        if (scripts.head.begin) {
          head.insertBefore(
            range.createContextualFragment(scripts.head.begin), head.firstChild
          )
        }
      }

      // append to body
      range.selectNode(document.body)
      if (scripts.hasOwnProperty('body')) {
        const body = document.body
        if (scripts.body.begin) {
          body.insertBefore(
            range.createContextualFragment(scripts.body.begin), body.firstChild
          )
        }
        if (scripts.body.end) {
          body.appendChild(
            range.createContextualFragment(scripts.body.end)
          )
        }
      }
    }
  }
}
